import { createLoadableComponent, createModuleLoader } from '@mews/framework';
import { TextKey } from '@mews-distributor/common';

import { showRates } from '../../actions/navigation';
import { createViewLoadingError } from '../../components/common/createViewLoadingError';

import { moduleId } from './constants';

export const loader = createModuleLoader({
    name: moduleId,
    load: async () => import(/* webpackChunkName: "summary" */ './module'),
    dependencies: [],
});

export const Summary = createLoadableComponent({
    loader,
    component: 'SummaryView',
    ...createViewLoadingError({
        loadingStatusTextKey: TextKey.PreparingSecureCheckout,
        dismissAction: showRates,
    }),
});
